import { AfterViewInit, Component, DestroyRef, ElementRef, OnInit, ViewChild, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivityStreamState } from '../../data/activity-stream.state';
import { LoadActivityStreamItems } from '../../data/activity-stream.actions';
import { ActivityStreamItem } from '@coin/shared/activity-stream/util';
import { GlobalEventsService, TinyHelpers } from '@coin/shared/core/util-helpers';
import { Store } from '@ngxs/store';

@Component({
  selector: 'coin-c-activity-stream-list',
  templateUrl: './activity-stream-list.component.html',
  styleUrls: ['./activity-stream-list.component.scss'],
  standalone: false
})
export class ActivityStreamListComponent implements OnInit, AfterViewInit {
  private events = inject(GlobalEventsService);
  private store = inject(Store);
  private destroyRef = inject(DestroyRef);

  items$ = this.store.select<ActivityStreamItem[]>(ActivityStreamState.items);
  public items: ActivityStreamItem[];

  @ViewChild('scrollContainer') scrollContainer: ElementRef<HTMLElement>;
  private lastScrollTop = 0;

  public ngOnInit(): void {
    this.listenToItems();

    this.events
      .listen('click')
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => this.clickout());
  }

  public ngAfterViewInit(): void {
    this.scrollContainer.nativeElement.onscroll = (event: WheelEvent) => {
      if (TinyHelpers.scrolledOverVerticalBound(event, this.lastScrollTop)) {
        this.lastScrollTop = (event.target as HTMLElement).scrollTop;
        this.store.dispatch(new LoadActivityStreamItems(false));
      }
    };
  }

  public toggleItemDetails(clickedItem?: ActivityStreamItem): void {
    this.items.forEach(item => {
      if (item.id !== clickedItem.id) {
        item.isDetailVisible = false;
      } else {
        item.isDetailVisible = !item.isDetailVisible;
      }
    });
  }

  private listenToItems(): void {
    this.items$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(items => {
      this.items = structuredClone(items);
    });
  }

  clickout = (): void => {
    this.items.forEach(item => {
      item.isDetailVisible = false;
    });
  };
}
